import React, { Component } from 'react';
import {Button, Col} from "react-bootstrap";
import Row from "react-bootstrap/lib/Row";
import QRCodeGuide from "./mobile/QRCodeGuide";
import {scanCode, showAlert} from "./global/Scanner";
import {getEndpoint} from "./global/AppMode";


export default class MobileHomePage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: window.localStorage.getItem("mandants") ? [...JSON.parse(window.localStorage.getItem("mandants"))] : [],
        }
    }

    _scanBarCode = () => {
        scanCode().then((text) => {
            if (!text) {
                return;
            }
            let dataObj;
            try {
                dataObj = JSON.parse(text);
            } catch (e) {
                showAlert('QR neobsahuje validne data.', 'Chyba');
                return;
            }
            let mandants = window.localStorage.getItem('mandants');
            mandants = mandants ? JSON.parse(mandants) : [];

            if (!this._containsMandant(dataObj)) {
                mandants.push(dataObj);
            }

            window.localStorage.setItem('mandants', JSON.stringify(mandants));
            this.setState({ data: mandants });
        });
    };

    _containsMandant = (data) => {
        let mandants = window.localStorage.getItem("mandants");
        if (mandants) {
            mandants = JSON.parse(mandants);
            for (let i = 0; i < mandants.length; i++) {
                if (mandants[i].idMandant === data.idMandant && mandants[i].instance === data.instance) {
                    return true;
                }
            }
        }

        return false;
    }

    _redirect = (instance, idMandant) => {
        this.props.history.replace("/" + instance + "/" + idMandant);
    }

    render() {
        return (
            <div style={{width: "100%", textAlign: "center", padding: "5px"}}>
                <Button className="mobile-qr-button" onClick={this._scanBarCode}>
                    <img src="assets/css/icons/svg/barcode.svg" style={{width: "200px"}}/><br/>
                    <i className="icon icon-camera" style={{fontSize: "30px"}}></i>
                </Button>
                {this.state.data.length === 0 ?
                    <QRCodeGuide/>
                    :
                    <div>
                        {this.state.data.map((entry, index) => {
                            return (
                                <Button key={index} className="mobile-homepage-card-button" onClick={() => this._redirect(entry.instance, entry.idMandant)}>
                                    <Row style={{display: "flex", width: "100%", height: "40px"}}>
                                        <Col style={{top: 0, bottom: 0, marginTop: "auto", marginBottom: "auto"}} md={4}>
                                            <img style={{maxWidth: "120px", maxHeight: "35px"}}
                                                 src={getEndpoint(entry.instance) + "PictureServlet?id=" + entry.idMandant + "&action=GET_MANDANT_LOGO"}
                                                 className="img-responsive center-block" alt="mandant_logo"/>
                                        </Col>
                                        <Col style={{top: 0, bottom: 0, marginTop: "auto", marginBottom: "auto"}} md={8}>
                                            {entry.mandantName}
                                        </Col>
                                    </Row>
                                </Button>
                            )
                        })}
                    </div>
                }
            </div>
        );

    }
}